import { render, staticRenderFns } from "./Contactr.vue?vue&type=template&id=6c4898f8&"
import script from "./Contactr.vue?vue&type=script&lang=js&"
export * from "./Contactr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports